import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform  } from '@angular/core';
import { MdSnackBar } from '@angular/material';
//import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { TestingBillService, CommonService, SubscribeService } from '../../../services/index';
import { TestingBillModel, ClientModel } from '../../../model/index';

@Component({
    selector: 'add-edit-testing-bill-tab',
    templateUrl: './addEditTestingBill.component.html',
})
export class AddEditTestingBillComponent implements OnInit {
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    public pocdata: any[] = [];

    isLoadMask: Promise<any>;
    pocData: TestingBillModel[];
    isLoading: boolean = false;
    minDate: any;
    usertype: any;
    filteredSrc: Observable<any[]>;
    filteredBranch: Observable<any[]>;

    @Input() testingbilldata: TestingBillModel[] = [];
    @Input() testingtypedata: TestingBillModel[] = [];
    testdate:any;
    testingbillCtrl: FormControl;
    srclistCtrl: FormControl;
    filteredItems: Observable<any[]>;
    testingtypeCtrl: FormControl;
    filteredTypes: Observable<any[]>;
    branchCtrl: FormControl;
    @ViewChild('testingbillAutoComp') testingbillAutoComp;
    @ViewChild('testingtypeAutoComp') testingtypeAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('editColumnTemplate') editColumnTemplate: TemplateRef<any>;
    @ViewChild('testDescColumnTemplate') testDescColumnTemplate: TemplateRef<any>;

    clientList: any[] = [];
    testingList: any[] = [];
    srcList: any[] = [];
    branchList: any[] = [];
    cashType =['CARD','CASH', 'CREDIT','CHEQUE', 'ONLINE', 'CASH&CARD'];
    constructor(private testingbillService: TestingBillService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService,public store: Store<fromRootStore.State>) {

        // this.testingtypeCtrl = new FormControl();
        // this.filteredTypes = this.testingtypeCtrl.valueChanges
        //     .startWith(null)
        //     .map(name => name ? this.filterTypes(name) : this.testingList.slice());
   function hasValidTestType(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidTesting: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidTesting: true };
            }
            return retVal;
        }
        this.testingbillCtrl = new FormControl('', [
            Validators.required,
            hasValidTestType.bind(this)
        ]);
       // this.testingbillCtrl = new FormControl();
       function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            Validators.required,
            hasSrc.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());


            this.branchCtrl = new FormControl();
            this.filteredBranch = this.branchCtrl.valueChanges
                .startWith(null)
                .map(name => name ? this.filterBranch(name) : this.branchList.slice());
    
            function hasValidBranch(input: FormControl) {
                let branchID = input.value, retVal = null;
                if (branchID && typeof branchID === "string") {
                    retVal = { inValidBranch: true };
                }
                return retVal;
            }
            this.branchCtrl = new FormControl('', [
                Validators.required,
                hasValidBranch.bind(this)
            ]);
    }

    reorderable: boolean = true;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    columns = [];
    testingDetails = [];
    totalDetails = [];
    testbilldetail = [];
    ngOnInit(): void {
        this.testingbilldata['type'];
        let that = this;
        this.loadSrcList();
        //this.loadClientTypeList();
        //this.testingtypeAutoComp.optionSelected.subscribe(this.onSelectedTestingtype.bind(this));
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Testing Details', width: 200, minWidth: 200, maxWidth: 200, sortable: false, cellClass: 'cell-left', cellTemplate : this.testDescColumnTemplate },
            { name: 'Amount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right', cellTemplate : this.editColumnTemplate },
            //{ name: 'Action', prop: 'sno', maxWidth: 70, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.filterClientName();
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate());
        this.testingbilldata['date'] = new Date();
        this.testingbilldata['usertype'] = this._params['user_role_type'];
        this.testingbilldata['branch'] = this._params['branchName']; 
        }

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && auth['usertype'] == 'User') {
                this.testingbilldata['branch'] = auth['branch_id'];
                this.branchCtrl.disable();
            }
            this.usertype = auth['usertype'];
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                this.store.dispatch(new commonActions.LoadAllBrand());
                this.branchList = res.data;
                return;
            }
            if(this.usertype=='HV'){
                this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' && obj['store_branch'] == 'Yes'});
            } else {
                this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false'});
            }
            
            //this.displayBranchFn(this.clientdata['branch']);
            this.branchCtrl.setValue(this.testingbilldata['branch']);
        });
        
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'testBill',
                date: moment(this.testingbilldata['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function(res: any) {
                if (res['success']) {
                    that.testingbilldata['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadSrcList () {
        let that = this,
            data = {
                name: ''
            };
        this.commonService
            .getBankLedger(data)
            .then(function (res: any) {
                that.srcList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.srclistCtrl.setValue(that.testingbilldata['bank']);
                //that.srclistCtrl.setValue(that.clientInData['bank_name']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

     filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(ha => (new RegExp(bank_name, 'gi').test(ha.bank)
            || new RegExp(bank_name, 'gi').test(ha.bank_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'bank': item_id }),
                bank_name = fhalist.bank_name;
                this.testingbilldata['bank_name'] = bank_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['bank_name'];
        }
        return '';
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let branchObj = _.find(this.branchList, { 'branch_id': parseInt(branchID.toString()) });
            return branchObj['branch_name'];
        }
        else if(branchID){
            return branchID
        }
        else{
            return '';
        }    
    }

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.clientList.filter(client => (new RegExp(name, 'gi').test(client.client_code) || new RegExp(name, 'gi').test(client.client_no)));
    }

    displayFn(bill_id: number) {
        if (bill_id && this.clientList.length > 0) {
            let fclient = _.find(this.clientList, { 'client_id': bill_id });
            this.testingbilldata['client_name'] = fclient.client_name; //ANOTHER FIELD
            let that = this,
             data = {
                client_id : fclient.client_id,
                outType : 'Testing',
                date: moment(this.testingbilldata['date']).format('YYYY-MM-DD'),
                ha_id: '',
                hvoutstaus: ''
            };

            this.commonService
            .getTestingTypeDet(data)
            .then(function (res: any) {
                that.page.count = res.totCnt;
                that.testingDetails = res.data;
                // this.testingDetails = res.data;
                that.calGrossTotal();
            });
            return fclient['client_no'];
          
        }
        return '';
    }
    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.testingbilldata = Object.assign({}, this._params);
            if(mode == 'HVEdit')
            {
                this.testingbilldata['hidden_client'] = this._params['client_no'];
                this.testingbilldata['date'] = new Date(this._params['date']);
                let that = this,
             data = {
                client_id : this._params['client_id'],
                ha_det_id: this._params['ha_det_id'],
                ha_id: this._params['ha_id'],
                outType : 'HVTesting',
                date: moment(this.testingbilldata['date']).format('YYYY-MM-DD')
            };

            this.commonService
            .getTestingTypeDet(data)
            .then(function (res: any) {
                that.page.count = res.totCnt;
                that.testingDetails = res.data;
                // this.testingDetails = res.data;
                that.calGrossTotal();
                that.loadAutoNumber();
            });
                // this.getTestingbillDetailList();
            }else if (mode != 'Add') {
                this.testingbilldata['hidden_client'] = this._params['client_no'];
                this.testingbilldata['date'] = new Date(this._params['date']);
                this.getTestingbillDetailList();
                this.branchCtrl.disable();

            } 
            
            this.mode = mode;
        }
    }

    getTestingbillDetailList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'bill_id',
                orderDir: `${this.page.orderDir}`,
                bill_id: this.testingbilldata['bill_id']
            };

        this.isLoadMask = this.testingbillService
            .getTestingbillDetailList(params)
            .then(function(res: any) {
                that.page.count = res.totCnt;
                that.testingDetails = res.data;
               
            });
    }

    // loadClientTypeList() {
    //     let that = this;
    //     this.commonService
    //         .getTestingtypeList()
    //         .then(function(res: any) {
    //             that.testingList = res;
    //             that.testingtypeCtrl.setValue(that.testingtypedata['id']);
	// 			/*if (that.mode == "Edit") {
	// 			  that.brandCtrl.disable();
	// 			  $('#name').focus();
	// 			}*/
    //         });
    // }

    // filterTypes(name: string) {
    //     name = _.escapeRegExp(name);
    //     return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name) || new RegExp(name, 'gi').test(type.fees)));
    // }
    //
    // displayType(type_id: number) {
    //
    //     if (type_id && this.testingList.length > 0) {
    //         let ftype = _.find(this.testingList, { 'id': type_id });
    //         return ftype['name'];
    //     }
    //     return '';
    // }

    onSelectedTestingtype(mdCompEvent: any) {
        let type_id = mdCompEvent.option.value,
            ftype = _.find(this.testingList, { 'id': type_id });

        this.testingtypedata['testingtype_name'] = ftype.name;
        this.testingtypedata['testingtype_fees'] = ftype.fees;
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onDeleteTestingbill(row: any): void {

        let that = this,
            mode = this.testingbilldata['mode'];

        if (mode == 'Add') {
            this.testingDetails.splice(this.testingDetails.indexOf(row), 1);
            this.testingtypedata = [];

        } else if (mode == 'Edit') {
            let params = {
                id: row.id,
                testingtype_name: row.testingtype_name,
                bill_id: row.bill_id
            };

            this.testingbillService
                .deleteGridList(params)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.testingDetails.splice(that.testingDetails.indexOf(row), 1);
                        that.testingtypedata = [];
                        that.calGrossTotal();
                        //that.getTestingbillDetailList();

                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                })
        }

        this.calGrossTotal();

    }

    addTestingbill(): void {
        let that = this,
            mode = this.testingbilldata['mode'],
            testing_id = this.testingtypedata['id'];

        if (!_.isEmpty(testing_id)) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.testingDetails, { 'id': testing_id });

            if (preTestID) {
                let testName = this.testingtypedata['testingtype_name'];
                swal('WARNING', 'Testing Detail : ' + testName + ' Already Exists');
                return;
            }

            if (mode == 'Add') {
                let testDet = Object.assign({}, this.testingtypedata);
                this.testingDetails.push(testDet);
                this.testingtypedata = [];
                that.page.count = this.testingDetails.length;
                that.calGrossTotal();
            } else if (mode == 'Edit') {
                let testDet = Object.assign({}, this.testingtypedata),
                    params = {
                        id: this.testingtypedata['id'],
                        testingtype_name: this.testingtypedata['testingtype_name'],
                        testingtype_fees: this.testingtypedata['testingtype_fees'],
                        bill_id: this.testingbilldata['bill_id']
                    };

                //this.testingDetails.push(testDet);
                //this.testingtypedata = [];
                //that.page.count = this.testingDetails.length;
                this.testingbillService
                    .addTestingbill(params)
                    .then(function(res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            let testDet = Object.assign({}, that.testingtypedata);
                            that.testingDetails.push(testDet);
                            that.page.count = that.testingDetails.length;
                            swal('SUCCESS', res.message, 'success');
                            that.testingtypedata = [];
                            that.calGrossTotal();
                            //that.getTestingbillDetailList();
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    });
            }
        }
    }
    calGrossTotal() {
        let gross_total = 0;

        for (let i = 0; i < this.testingDetails.length; i++) {
            if( this.testingDetails[i].testingtype_name == 'Re-programming+PTA' || this.testingDetails[i].testingtype_name == 'Re-Checkup+PTA'){
                this.testingDetails[i].testingtype_fees = 0;
            }
         
            let testingtype_fees = this.testingDetails[i].testingtype_fees;
            gross_total += Number(testingtype_fees);
        }
        this.testingbilldata['gross_total'] = gross_total;
        this.calGrantTotal();
    }

    calGrantTotal() {
        let gross_total = this.testingbilldata['gross_total'],
            dis_per = this.testingbilldata['discount_percentage'],
            dis_amt = 0,
            grant_total = 0;

        if (!_.isEmpty(_.toString(dis_per))) {
            dis_amt = (gross_total * dis_per) / 100;
        }
        if (!_.isEmpty(_.toString(gross_total))) {
            grant_total = gross_total - dis_amt;
        }

        this.testingbilldata['discount_amount'] = dis_amt;
        this.testingbilldata['amount'] = grant_total;
    }

    onSaveTestingbill(): void {
        if(this.testingbilldata['mode'] == 'HVEdit'){
            this.testingbilldata['ha_id'] = this._params['ha_id'],
            this.testingbilldata['hvoutstaus'] = 'yes',
            this.testingbilldata['mode'] = 'Add';
            this.testingbilldata['hv_st_det_id'] = this._params['st_det_id'];
        }
        if( this.testingbilldata['hvoutstaus'])
        {
            this.testingbilldata['hvoutstaus'] ='yes';
        }else {
            this.testingbilldata['hvoutstaus'] ='no';
        }
        if(this.testingbilldata['ha_id'])
        {
            this.testingbilldata['ha_id'] = this.testingbilldata['ha_id'];
        }
        else{
            this.testingbilldata['ha_id'] ='';
        }
        if(this.testingbilldata['hv_st_det_id'])
        {
            this.testingbilldata['hv_st_det_id'] = this.testingbilldata['hv_st_det_id'];
        }
        else{
            this.testingbilldata['hv_st_det_id'] ='';
        }

        let that = this,
            mode = this.testingbilldata['mode'],
            testingDet = this.testingDetails.length,
            cash_amount = this.testingbilldata['cash_amt'],
            card_amount = this.testingbilldata['card_amt'],
            amount = this.testingbilldata['amount'];
          
        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Testing Details');
            return;
        }
        
        if (this.testingbilldata['type'] == 'CASH&CARD') {
            let tot = parseFloat(cash_amount) + parseFloat(card_amount);
                if (amount == tot) {
                    this.testingbilldata['amount'] = tot;
                } else {
                    swal('WARNING', ' Amount Does Not Match!!!');
                    return;
                }
           
        }
        let testingDate = moment(this.testingbilldata['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this.testingbilldata['bill_id'],
                auto_no: this.testingbilldata['auto_no'],
                branch_id: this.testingbilldata['branch'],
                date: testingDate,
                amount: this.testingbilldata['amount'],
                client_id: this.testingbilldata['client_id'],
                client_name: this.testingbilldata['client_name'],
                testingDetails: JSON.stringify(this.testingDetails),
                gross_total: this.testingbilldata['gross_total'],
                discount_percentage: this.testingbilldata['discount_percentage'],
                discount_amount: this.testingbilldata['discount_amount'],
                mode: this.testingbilldata['mode'],
                chqno: this.testingbilldata['chqno'],
                bank: this.testingbilldata['bank'],
                type: this.testingbilldata['type'],
                cash_amount : this.testingbilldata['cash_amt'],
                card_amount : this.testingbilldata['card_amt'],
                ha_id : this.testingbilldata['ha_id'],
                hvoutstaus :  this.testingbilldata['hvoutstaus'],
                hv_st_det_id : this.testingbilldata['hv_st_det_id'],
                telecare_app_installed: this.testingbilldata['telecare_app_installed'],
                roc_coupon_give: this.testingbilldata['roc_coupon_give'],
                roc_referral: this.testingbilldata['roc_referral'],
                roc_referral_number: this.testingbilldata['roc_referral_number'],
                google_review: this.testingbilldata['google_review'],
                testimonial: this.testingbilldata['testimonial'],
                contact_number_saved: this.testingbilldata['contact_number_saved'],
                saved_contact_number: this.testingbilldata['saved_contact_number'],
                uploaded_image: this.testingbilldata['uploaded_image'] || ''
            };
        this.isLoading = true;

        this.testingbillService
            .addUpdateTestingbill(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subReloadTestingBillListGrid();
                    that.testingbilldata = [];
                    that.testingDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });

    }
    changeDate(){
        this.testdate=this.testingbilldata['date'];
        this.filterClientName();
    }

    filterClientName(){
        let tdate= moment(this.testdate).format('YYYY-MM-DD');
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term         // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadTestClientList(term, 'testBill',tdate)
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.loadClientList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            this.clientList = $e;
        });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingBill/addEditTestingBill.component.ts